var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questions-placeholder"},[_c('div',{staticClass:"avatar-wrapper"},[_c('icon',{staticClass:"left-icon",attrs:{"name":"askme-question-bubble"}}),_c('icon',{staticClass:"right-icon",attrs:{"name":"askme-exclamation-bubble"}}),_c('img',{staticClass:"creator-avatar",attrs:{"src":_vm.creatorInfo.avatar}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }